<template>
    <ValidationObserver ref="form" v-slot="{ invalid }">
        <div class="absolute top-0 left-0 right-0 bottom-0 w-full overflow-hidden flex items-center text-center justify-center z-50" v-show="loading"><spinner line-fg-color="#922C49" size="55" :line-size="5"></spinner></div>
        <form id="form" v-if="!loading" @submit.prevent="submitForm" class="flex flex-col h-full">
            <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
                <template slot="title">{{ type }} Custom Field</template>
            </page-header>

            <tabs :tabs="tabs" :active="startTab" @setTab="setActiveTab" ref="tabs"></tabs>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" role="alert" v-show="invalid && submitted" >Please complete all required fields</div>
            <div class="bg-red-200 py-2 text-sm text-red-700 text-center w-full -mt-px" v-if="errorMessage">{{ errorMessage }}</div>

            <div class="flex md:flex-row sm:flex-col flex-grow">
                <div class="md:w-3/4 sm:w-full px-4 sm:px-6 lg:px-6 bg-gray-200 border-r border-gray-400" v-show="activeTab === 'details'">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-select class="sm:col-span-4"
                                label="Section"
                                placeholder="Section"
                                name="model"
                                v-model="item.model"
                                :initialValue="initialValue.model"
                                return="value"
                                rules="required"
                                :required="true"
                                :options="options.models"
                            />
                            <input-select class="sm:col-span-4"
                                label="Field Type"
                                placeholder="Field Type"
                                name="type"
                                v-model="item.type"
                                :initialValue="initialValue.type"
                                return="value"
                                :required="false"
                                :options="options.types"
                                @input="typeChanged"
                            />
                            <input-select class="sm:col-span-4"
                                label="Width"
                                placeholder="Width"
                                name="width"
                                v-model="item.width"
                                :initialValue="initialValue.width"
                                return="value"
                                :required="true"
                                :options="options.widths"/>
                            <input-text class="sm:col-span-12"
                                label="Label"
                                placeholder="Label"
                                name="label"
                                v-model="item.label"
                                rules="required"
                                :required="true"
                            />
                            <div class="col-span-12 flex flex-col" v-if="item.type === 'selectInput' || item.type === 'radioInput' || item.type === 'checkboxInput'">
                                <label class="block font-medium leading-5 text-gray-800 relative mb-1 cursor-pointer text-xs">
                                    Options
                                </label>
                                <div class="flex flex-row">
                                    <span class="block font-medium leading-5 text-gray-800 relative mb-1 text-xs w-1/2">Label</span>
                                    <span class="block font-medium leading-5 text-gray-800 relative mb-1 text-xs w-1/2 -ml-2">Value (Optional)</span>
                                </div>
                                <div class="flex flex-row mb-2" v-for="(option, optionIndex) in itemOptions" :key="option.id">
                                    <input type="text" placeholder="Name" v-model="option.label" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700 mr-2"/>
                                    <input type="text" placeholder="Value" v-model="option.value" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700"/>
                                    <button type="button" class="pr-1" @click="removeOption(optionIndex)">
                                        <font-awesome-icon class="text-lg outline-none text-default-500 ml-3" :icon="['fas', 'times']" />
                                    </button>
                                </div>
                                <button type="button" class="bg-default-500 hover:bg-default-600 text-white px-4 py-2 text-xs border-0 w-32" @click="addOption">
                                    <font-awesome-icon class="text-white text-xs mr-2" :icon="['fal', 'plus']"/>
                                    Add Option
                                </button>
                            </div>
                        </div>
                    </ValidationObserver>
                </div>
                <div class="md:w-1/4 sm:w-full px-4 sm:px-6 lg:px-6">
                    <ValidationObserver vid="details" :slim="true">
                        <div class="mt-6 grid grid-cols-1 row-gap-5 col-gap-4 sm:grid-cols-12">
                            <input-toggle class="sm:col-span-6"
                                label="Required"
                                name="required"
                                v-model="item.required"
                                :required="false" />
                            <input-toggle class="sm:col-span-6"
                                label="Active"
                                name="active"
                                v-model="item.active"
                                :required="false" />

                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </form>
        <transition name="fade">
            <delete-confirmation-modal v-if="showDeleteModal" @close="closeDeleteModal" @delete="deleteItem" ref="datatableDeleteModal">
                <template slot="content">Are you sure you want to delete the <strong>{{ item.label }}</strong>?</template>
            </delete-confirmation-modal>
        </transition>
    </ValidationObserver>
</template>

<script>
    import axios from "axios";
    import FormSetup from "../../../mixins/Tabs";
    import FormButtons from "../../../mixins/FormButtons";
    import DeleteModal from "../../../mixins/DeleteModal";


    export default {
        name: "CustomFieldForm",
        props: {
            id: {required: false},
            type: {required: true},
            return: {required: false, default: '/configuration/custom-fields'},
            page: {required: false, default: 'custom-fields'}
        },
        mixins: [
            FormSetup,
            FormButtons,
            DeleteModal
        ],
        data: function () {
            return {
                resource: 'custom-fields',
                pageActions: {
                    buttons: [
                        {
                            label: 'Save',
                            icon: 'save',
                            iconClass: 'text-green-600',
                            type: 'method',
                            method: 'save',
                        },
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-600',
                            type: 'method',
                            method: 'cancel',
                        }
                    ],
                    additional: []
                },
                tabs: [
                    {
                        name: 'Details',
                        slug: 'details'
                    }
                ],
                startTab: null,
                loading: true,
                submitted: false,
                errorMessage: '',
                item: {},
                itemOptions: [],
                options: {
                    types: [
                        {label: 'Text', value: 'textInput'},
                        {label: 'Long Text', value: 'longTextInput'},
                        {label: 'Number', value: 'numberInput'},
                        {label: 'Select', value: 'selectInput'},
                        {label: 'Radio', value: 'radioInput'},
                        {label: 'Checkbox', value: 'checkboxInput'},
                        //{label: 'File Upload', value: 'fileUpload'},
                        {label: 'Date', value: 'dateInput'},
                        //{label: 'Heading', value: 'heading'},
                    ],
                    widths: [
                        {label: '25%', value: '3'},
                        {label: '33%', value: '4'},
                        {label: '50%', value: '6'},
                        {label: '75%', value: '9'},
                        {label: '100%', value: '12'},
                    ],
                    displays: [
                        {label: 'Horizontal', value: 'horizontal'},
                        {label: 'Vertical', value: 'vertical'},
                    ],
                    models: []
                }
            }
        },
        methods: {
            typeChanged: function (payload){
                if (payload === 'selectInput' || payload === 'radioInput' || payload === 'checkboxInput'){
                    if (this.itemOptions.length === 0){
                        this.itemOptions.push({
                            label: '',
                            value: ''
                        });
                    }
                }
            },
            addOption: function () {
                this.itemOptions.push({
                    label: '',
                    value: ''
                });
            },
            removeOption: function (index) {
                this.itemOptions.splice(index, 1);
            },
            getData: function () {
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/custom-fields/' + this.id).then(response => {
                    this.item = response.data;
                    this.itemOptions = this.item.options;
                    this.$Progress.finish();
                    this.loading = false;
                }).catch(() => {
                    this.$Progress.finish();
                    this.loading = false;
                });
            },
            submitForm: function () {
                this.submitted = false;

                this.$refs.form.validate().then(success => {
                    let _method;
                    let _url;

                    if (!success) {
                        this.submitted = true;
                        return;
                    }

                    this.submitted = true;

                    this.$store.commit('TOGGLE_BACKDROP', {open: true});
                    this.errorMessage = '';

                    if (this.id) {
                        _url = process.env.VUE_APP_API_URL + '/custom-fields/' + this.id;
                        _method = 'PUT';
                    } else if (this.item.id) {
                        _url = process.env.VUE_APP_API_URL + '/custom-fields/' + this.item.id;
                        _method = 'PUT';
                    } else {
                        _url = process.env.VUE_APP_API_URL + '/custom-fields';
                        _method = 'POST';
                    }

                    this.item.options = this.itemOptions;

                    axios({
                        method: _method,
                        url: _url,
                        data: this.item
                    }).then(response => {
                        if (response.data.success) {
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});

                            if (this.saveClose) {
                                if (this.return) {
                                    this.$router.push(this.return);
                                } else {
                                    this.$router.push('/configuration/custom-fields');
                                }
                            } else {
                                this.$router.push('/configuration/custom-fields');
                            }

                            this.$notify({
                                group: 'main',
                                type: 'success',
                                title: 'Success',
                                text: response.data.message,
                                duration: 5000
                            });

                        } else {
                            if (response.data.message) {
                                this.errorMessage = response.data.message;
                            }
                            this.$store.commit('TOGGLE_BACKDROP', {open: false});
                        }
                    }).catch(error => {
                        if (error.response.data.message) {
                            this.errorMessage = error.response.data.message;
                        } else {
                            this.errorMessage = 'An error occurred. Please contact the System Administrator.';
                        }

                        this.$store.commit('TOGGLE_BACKDROP', {open: false});
                    });
                });
            },
            cancel: function () {
                this.$router.push(this.return);
            },
            methodHandler: function (method) {
                this[method]();
            },
            actionHandler: function (data) {
                this[data.method](data);
            },

        },
        beforeMount() {
            // Custom Field Types
            this.$store.dispatch('GET_CUSTOM_FIELD_MODELS').then(() => {
                this.options.models = this.$store.getters.customFieldModels.map(function (type) {
                    return { label: type.name, value: type.name };
                });
            });
        },
        mounted() {
            if (this.type === "New") {
                this.loading = false;
                this.item.active = true;
                this.item.required = false;
                this.item.width = 12;
                this.item.model = 'Member';
                this.item.options = [];
                this.$Progress.finish();
                // Se defaults here
            } else if (this.type === "Edit") {
                this.pageActions.additional.push({
                    label: 'Delete',
                    icon: 'trash-alt',
                    type: 'method',
                    method: 'deleteModal',
                    iconClass: 'text-red-500',
                    display: !!(this.$store.getters.permissions.indexOf('custom-fields.destroy') !== -1 || this.$store.getters.nimdarepus)
                });
                this.getData();
            }

            const params = new URLSearchParams(window.location.search)

            let windowLocationHash = window.location.hash.replace('#', '');

            if (windowLocationHash) {
                this.startTab = windowLocationHash;
            }
        },
        computed: {
            initialValue: function(){
                let output = {};

                if (this.item.model){
                    output['model'] = this.item.model;
                } else {
                    output['model'] = 'Member'
                }

                if (this.item.width){
                    output['width'] = this.item.width;
                } else {
                    output['width'] = null
                }

                return output;
            }
        }
    }
</script>

<style scoped>

</style>
